
import React from "react";
import { ArrowRight, Globe } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { useNavigate } from "react-router-dom";
import { CardWaitlist } from "./CardWaitlist";

interface CardActionsProps {
  countySlug: string;
  nhSlug: string;
  centerName: string;
  websiteUrl?: string;
  onTrackClick: (type: string) => void;
  isInLeads: boolean;
  setIsInLeads: (value: boolean) => void;
  email?: string;
}

export function CardActions({
  countySlug,
  nhSlug,
  centerName,
  websiteUrl,
  onTrackClick,
  isInLeads,
  setIsInLeads,
  email
}: CardActionsProps) {
  const navigate = useNavigate();
  
  const handleViewDetails = () => {
    onTrackClick('view_details');
    navigate(`/nursing-homes/${countySlug}/${nhSlug}`);
  };
  
  return (
    <div className="flex flex-col gap-3">
      <div className="flex gap-2">
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button 
                variant="default" 
                onClick={handleViewDetails}
                className="flex-1 bg-grandpal-green-dark"
              >
                View Details
                <ArrowRight className="h-4 w-4 ml-1" />
              </Button>
            </TooltipTrigger>
            <TooltipContent>View detailed information</TooltipContent>
          </Tooltip>
        </TooltipProvider>
        
        <div className="flex gap-1">
          {websiteUrl && (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Button 
                    variant="outline" 
                    size="icon" 
                    onClick={() => {
                      onTrackClick('website');
                      window.open(websiteUrl, '_blank');
                    }} 
                    aria-label={`Visit ${centerName} website`}
                  >
                    <Globe className="h-4 w-4" />
                  </Button>
                </TooltipTrigger>
                <TooltipContent>Visit website</TooltipContent>
              </Tooltip>
            </TooltipProvider>
          )}
        </div>
      </div>
      
      {/* Add Waitlist Button */}
      <CardWaitlist
        centerName={centerName}
        countySlug={countySlug}
        nhSlug={nhSlug}
        onTrackClick={onTrackClick}
        isInLeads={isInLeads}
        setIsInLeads={setIsInLeads}
        email={email}
      />
    </div>
  );
}
